import {FuseRouteItemType} from '@fuse/utils/FuseUtils';
import {Navigate} from 'react-router';

import {AUTH_ROLES} from '@/app/auth/authRoles';
import LinkExpiredPage from '@/app/main/authentication/pages/LinkExpired/LinkExpiredPage';

import DownloadAppPage from '../onboarding/pages/DownloadApp/DownloadAppPage';

import AuthenticationPage from './AuthenticationPage';
import AuthenticationGuard from './guard/AuthenticationGuard';
import ChangePasswordPage from './pages/ChangePasswordPage/ChangePasswordPage';
import PasswordChangedPage from './pages/ChangePasswordPage/pages/PasswordChangedPage/PasswordChangedPage';
import ResetPasswordPage from './pages/ResetPassword/ResetPasswordPage';
import SignInPage from './pages/SignIn/SignInPage';
import SignUpPage from './pages/SignUp/SignUpPage';
import VerifySMSPage from './pages/VerifySMS/VerifySMSPage';

const AuthenticationRoute: FuseRouteItemType = {
  path: 'authentication',
  element: (
    <AuthenticationGuard>
      <AuthenticationPage />
    </AuthenticationGuard>
  ),
  auth: AUTH_ROLES.onlyGuest, // []

  children: [
    {
      path: '',
      element: <Navigate to="sign-in" />,
    },
    {
      path: '*',
      element: <Navigate to="sign-in" />,
    },
    /**
     * this parameter is used to bypass the authentication
     * guard just for app mobile biometric debug reasons
     */
    {
      path: 'sign-in/:authByPass?',
      element: <SignInPage />,
    },
    {
      path: 'sign-up',
      element: <SignUpPage />,
    },
    {
      path: 'verify',
      element: <VerifySMSPage />,
    },
    {
      path: 'password/forgot',
      element: <ResetPasswordPage />,
    },
    {
      path: 'password/reset',
      element: <ChangePasswordPage />,
    },
    {
      path: 'password/changed',
      element: <PasswordChangedPage />,
    },
    {
      path: 'password/link-expired',
      element: <LinkExpiredPage />,
    },
    {
      path: 'download-app',
      element: <DownloadAppPage />,
    },
  ] as FuseRouteItemType[],
};

export default AuthenticationRoute;
